import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { Employment } from '../../employment/employment-model';
import { useMemberEmployment } from '../member/hooks/useMemberEmployment';

export function useMemberHireDate() {
	useMemberEmployment();
	const memberEmployment = useSelector<TcsmStates, Employment>(state => state?.newHireEnrollmentState?.memberEmployment);
	return memberEmployment?.hire_date;
}